import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-hidden"]

import { RcIconSizeToCSS, RcIconTypeToClass, RcIconProps } from './types';
import { computed } from 'vue';
import { useStatusColors } from '@components/utils/status';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcIcon',
  props: {
    type: {},
    size: { default: 'small' },
    ariaHidden: { type: Boolean, default: true },
    status: { default: 'inherit' }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v7e6a977a": (fontSize.value),
  "v684855ce": (color.value)
}))

const props = __props;
const fontSize = computed(() => {
  return RcIconSizeToCSS[props.size];
});

const iconClass = computed(() => {
  return RcIconTypeToClass[props.type];
});

const status = computed(() => {
  if (props.status && props.status !== 'inherit') {
    return props.status;
  }

  return 'none';
});

const { textColor } = useStatusColors(status, 'outlined');

const color = computed(() => {
  if (props.status === undefined || props.status === 'inherit') {
    return 'inherit';
  }

  return textColor.value;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["rc-icon", {[props.size]: true, [iconClass.value]: true}]),
    "aria-hidden": props.ariaHidden
  }, null, 10, _hoisted_1))
}
}

})